import React from 'react'
import { Button, Paper } from '@mui/material'
import classNames from 'classnames'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import WarningComponent from '@app/components/Common/Warning/WarningComponent'
import EcoModeDevicesList from './EcoModeDevicesList/EcoModeDevicesList'

interface Props {
  classes: Record<string, string>,
  admin: boolean,
  ecoModeDevices: any[],
  isMobile: boolean,
  isTurnOffPopupOpen: boolean,
  selectCurrentEcoModeDeviceId: (id: number) => void,
  selectCurrentEcoModeDeviceStatus: (status: boolean) => void,
  patchCurrentEcoModeDevice: (...args: any[]) => void,
  postEcoModeDevicesTurnOff: (...args: any[]) => void,
  openTurnOffPopup: (...args: any[]) => void,
  closeTurnOffPopup: (...args: any[]) => void,
}

class EcoMode extends React.Component<Props> {
  static displayName = 'EcoMode'

  componentWillUnmount() {
    const { closeTurnOffPopup } = this.props
    closeTurnOffPopup()
  }

  turnOffDevices = () => {
    const { openTurnOffPopup } = this.props
    openTurnOffPopup()
  }

  turnOffAccepted = () => {
    const { postEcoModeDevicesTurnOff, closeTurnOffPopup } = this.props
    postEcoModeDevicesTurnOff()
    closeTurnOffPopup()
  }

  turnOffDeclined = () => {
    const { closeTurnOffPopup } = this.props
    closeTurnOffPopup()
  }

  render() {
    const {
      classes,
      ecoModeDevices,
      isMobile,
      selectCurrentEcoModeDeviceId,
      selectCurrentEcoModeDeviceStatus,
      patchCurrentEcoModeDevice,
      isTurnOffPopupOpen,
      admin,
    } = this.props

    return (
      <Paper className={classNames(
        classes.main,
        !isMobile && classes.mainDesktop,
        (navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))
          && classes.webView,
      )}
      >
        <Wrapper className={classes.wrapper}>
          <Button
            disabled={!admin}
            className={classes.button}
            color="primary"
            onClick={this.turnOffDevices}
          >
            {I18n.t('buttons.eco_mode_energy')}
          </Button>
          <EcoModeDevicesList
            admin={admin}
            ecoModeDevices={ecoModeDevices}
            selectCurrentEcoModeDeviceId={selectCurrentEcoModeDeviceId}
            selectCurrentEcoModeDeviceStatus={selectCurrentEcoModeDeviceStatus}
            patchCurrentEcoModeDevice={patchCurrentEcoModeDevice}
          />
        </Wrapper>
        <WarningComponent
          open={isTurnOffPopupOpen}
          onClose={() => {
            this.turnOffDeclined()
          }}
          onClick={this.turnOffAccepted}
          warningText="confirmations.turn_off_all_eco_devices"
          leftButton="yeah"
          rightButton="nope"
        />
      </Paper>
    )
  }
}

export default EcoMode
